<template>
    <div id="weather-footer">
        <weather />
    </div>
</template>

<script>
import Weather from './Weather.vue'

export default {
  data () {
    return { 
    }
  },
  created () {
  },
  beforeDestroy () {
  },
  methods: {
  },
  components: {
    Weather
  }
}
</script>
